import { GreyBoxLoader, GreyCircleLoader, TextLoader } from '@xarvio/elements';
import { ColorCx, getBgColorCx, Text } from '@xarvio/corporate-styles';
import { Box, PageLayoutColumns, Row, RowCell } from '@xarvio/layout';
import React from 'react';
import loadingStyles from '../../../styles/loading.module.scss';
import cx from 'classnames';
import { CrossFarmDashboardFilterLoading } from './CrossFarmDashboardFilterLoading';

export const CrossFarmDashboardCommonPageLoading = () => {
  return (
    <PageLayoutColumns shiftForHeader>
      <div className={loadingStyles.panels}>
        <CrossFarmDashboardFilterLoading />
        <div
          className={cx(
            loadingStyles.panel,
            loadingStyles.panel_full,
            getBgColorCx(ColorCx.WHITE),
          )}
        >
          <Box hpadding={'medium'} vpadding={'narrow'} margin={false}>
            <Row
              align={'center'}
              gaps={'narrow'}
              margin={'large'}
              minHeight={40}
            >
              <RowCell auto>
                <GreyCircleLoader size={24} />
              </RowCell>
              <RowCell auto>
                <Text type={'h3'}>
                  <TextLoader width={'8em'} />
                </Text>
              </RowCell>
            </Row>
          </Box>

          <Box hpadding={'large'} vpadding={'narrow'} margin={false}>
            <GreyBoxLoader style={{ height: 84 }} />
          </Box>
        </div>
      </div>
    </PageLayoutColumns>
  );
};
